<template>
  <div class="payment-methods">
    <noda-apple-pay
      :showed="isNodaApplePay"
      :disabled="paymentMethodDisabled"
      :country="paymentRequestOptions.country"
      :currency="currency"
      :amount="totalAmount"
      :description="paymentRequestOptions.total.label"
      :qr-codes="qrCodes"
      :client-pays-fee="clientPaysFee"
      :payment-object="paymentObject"
    />
    <stripe-apple-google-pay
      :disabled="paymentMethodDisabled"
      :showed="isStripeAppleGooglePay"
      :client-pays-fee="clientPaysFee"
      :business="business"
      :payment-request-options="paymentRequestOptions"
      :amount="totalAmount"
      :payment-object="paymentObject"
      @stripeAppleGooglePayRendered="stripeAppleGooglePayRendered($event)"
    />
    <noda-credit-card
      :disabled="paymentMethodDisabled"
      :showed="isNodaCreditCard"
      :country="paymentRequestOptions.country"
      :currency="currency"
      :amount="totalAmount"
      :description="paymentRequestOptions.total.label"
      :qr-codes="qrCodes"
      :client-pays-fee="clientPaysFee"
      :payment-object="paymentObject"
    />
    <stripe-credit-card
      :disabled="paymentMethodDisabled"
      :showed="isStripeCreditCard"
      :client-pays-fee="clientPaysFee"
      :qr-codes="qrCodes"
      :currency="currency"
      :amount="totalAmount"
      :klarna-enabled="isKlarna"
      :payment-object="paymentObject"
    />
    <el-row v-if="!isSquashPayments">
      <KlarnaExpress
        :disabled="paymentMethodDisabled || payPalDisabled"
        :showed="isKlarna && !isSquashPayments"
        :client-pays-fee="clientPaysFee"
        :qr-codes="qrCodes"
        :currency="currency"
        :amount="totalAmount"
        :employee="employee"
        :payment-object="paymentObject"
      />
      <b
        v-if="isKlarna && payPalDisabled && termsAgree"
        class="disable-pay-pal-des"
        :style="{ color: primaryColor }"
      >{{ thresholdWarning("Klarna") }}</b>
    </el-row>
    <el-row v-if="!isSquashPayments">
      <pay-pal
        :disabled="paymentMethodDisabled || payPalDisabled"
        :showed="isPayPal && !isSquashPayments"
        :client-pays-fee="clientPaysFee"
        :amount="totalAmount"
        :currency="currency"
        :qr-codes="qrCodes"
        :business="business"
        :payment-object="paymentObject"
        @paypal-rendered="setPayPalButtonRenderStatus($event)"
      />
      <b
        v-if="isPayPal && payPalDisabled && termsAgree"
        class="disable-pay-pal-des"
        :style="{ color: primaryColor }"
      >{{ thresholdWarning("PayPal") }}</b>
    </el-row>
    <el-row v-if="(isPayPal || isKlarna) && isSquashPayments">
      <FurtherMethods :qr-codes="qrCodes">
        <el-row>
          <KlarnaExpress
            v-if="isKlarna"
            :disabled="paymentMethodDisabled || payPalDisabled"
            :showed="isKlarna"
            :client-pays-fee="clientPaysFee"
            :qr-codes="qrCodes"
            :currency="currency"
            :amount="totalAmount"
            :employee="employee"
            :payment-object="paymentObject"
          />
          <b
            v-if="isKlarna && payPalDisabled && termsAgree"
            class="disable-pay-pal-des"
            :style="{ color: primaryColor }"
          >{{ thresholdWarning("Klarna") }}</b>
        </el-row>
        <el-row>
          <pay-pal
            v-if="isPayPal"
            :disabled="paymentMethodDisabled || payPalDisabled"
            :showed="isPayPal"
            :client-pays-fee="clientPaysFee"
            :amount="totalAmount"
            :currency="currency"
            :qr-codes="qrCodes"
            :business="business"
            :payment-object="paymentObject"
            @paypal-rendered="setPayPalButtonRenderStatus($event)"
          />
          <b
            v-if="isPayPal && payPalDisabled && termsAgree"
            class="disable-pay-pal-des"
            :style="{ color: primaryColor }"
          >{{ thresholdWarning("PayPal") }}</b>
        </el-row>
      </FurtherMethods>
    </el-row>
    <noda-open-bank
      :disabled="paymentMethodDisabled"
      :showed="isNodaOpenBank"
      :country="paymentRequestOptions.country"
      :currency="currency"
      :amount="totalAmount"
      :description="paymentRequestOptions.total.label"
      :qr-codes="qrCodes"
      :client-pays-fee="clientPaysFee"
      :payment-object="paymentObject"
    />
  </div>
</template>

<script>
/* eslint-disable */
import NodaApplePay from "./Noda/NodaApplePay";
import StripeAppleGooglePay from "./Stripe/StripeAppleGooglePay";
import NodaCreditCard from "./Noda/NodaCreditCard";
import StripeCreditCard from "./Stripe/StripeCreditCard";
import KlarnaExpress from "./KlarnaExpress";
import PayPal from "./PayPal";
import NodaOpenBank from "./Noda/NodaOpenBank";
import FurtherMethods from "./FurtherMethods";
import queryStringMixin from "./query-string-mixin";

export default {
  name: "Methods",
  mixins: [queryStringMixin],
  components: {
    NodaApplePay,
    StripeAppleGooglePay,
    NodaCreditCard,
    StripeCreditCard,
    KlarnaExpress,
    PayPal,
    NodaOpenBank,
    FurtherMethods,
  },
  props: {
    showTeamName: {
      type: Boolean,
      default: false,
    },
    clientPaysFee: {
      type: Boolean,
      default: false,
    },
    termsAgree: {
      type: Boolean,
      default: false,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    totalAmount: {
      type: Number,
      default: 0,
    },
    tipAmount: {
      type: Number,
      default: 0,
    },
    qrCodes: {
      type: Array,
      default: () => {
        return [];
      },
    },
    currency: {
      type: String,
      default: "",
    },
    business: {
      type: Object,
      default: () => {
        return {};
      },
    },
    team: {
      type: Object,
      default: () => {
        return {};
      },
    },
    employee: {
      type: Object,
      default: () => {
        return {};
      },
    },
    paymentObject: {
      type: Array,
      default: () => {
        return [];
      },
    },
    primaryColor: {
      type: String,
      default: "#FF8A00",
    },
  },
  computed: {
    isSquashPayments() {
      return this.business?.squashPayments;
    },
    isNodaCreditCard() {
      return this.business.enabledPaymentMethods.includes("CreditCardNoda");
    },
    isNodaApplePay() {
      return this.business.enabledPaymentMethods.includes("ApplePayNoda");
    },
    isNodaOpenBank() {
      return this.business.enabledPaymentMethods.includes("OpenBankNoda");
    },
    isStripeCreditCard() {
      return this.business.enabledPaymentMethods.includes("CreditCard");
    },
    isStripeAppleGooglePay() {
      return (
        this.business.enabledPaymentMethods.includes("GooglePay") ||
        this.business.enabledPaymentMethods.includes("ApplePay")
      );
    },
    isKlarna() {
      return this.business.enabledPaymentMethods.includes("Klarna");
    },
    isPayPal() {
      return this.business.enabledPaymentMethods.includes("PayPal");
    },
    paymentMethodDisabled() {
      return this.termsAgree === false;
    },
    payPalDisabled() {
      if (
        this.business?.payPalConfig &&
        this.business.payPalConfig.thresholdEnabled
      ) {
        return this.tipAmount < this.business.payPalConfig.threshold;
      }
      return false;
    },
    payPalThreshold() {
      if (this.business?.payPalConfig) {
        return this.business.payPalConfig.threshold / 100;
      }

      return 5;
    },
  },
  data: function() {
    return {
      payPalButtonRendered: false,
      paymentRequestOptions: {
        country: process.env.VUE_APP_PAYMENT_COUNTRY_CODE,
        currency: this.currency.toLowerCase(),
        total: {
          label: this.preapareLabel(),
          amount: this.totalAmount,
        },
        requestPayerEmail: true,
      },
      showPayPal: false,
    };
  },
  mounted() {
    this.setQueryString();
  },
  methods: {
    thresholdWarning(paymentMethod = "PayPal") {
      return this.$t(`team.payment-method-disabled-des`, {
        paymentMethod,
        threshold: this.payPalThreshold,
        currency: this.currency,
      });
    },
    setPayPalButtonRenderStatus(rendered) {
      this.payPalButtonRendered = rendered;
    },
    preapareLabel() {
      if (this.isMultiple) {
        return `${this.$t("pay.tips-for")} ${this.business.name}`;
      } else if (this.showTeamName) {
        return `${this.$t("pay.tips-for")} ${this.team.name}`;
      } else {
        return `${this.$t("pay.tips-for")} ${
          this.employee.nickName
            ? this.employee.nickName
            : this.employee.name + " " + this.employee.surName
        } in ${this.business.name}`;
      }
    },
    stripeAppleGooglePayRendered(rendered = false) {
      if (rendered && this.business.hidePaypal) {
        this.showPayPal = false;
      } else {
        this.showPayPal = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.disable-pay-pal-des {
  font-family: "Raleway Medium", serif;
  font-size: 12px;
}
.payment-methods {
  .disabled-payment {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }

  max-width: 360px;
  width: 100%;
  margin: 0 auto;
}
</style>

<style lang="scss">
.payment-methods {
  .disabled-payment {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
}
</style>
